// extracted by mini-css-extract-plugin
export default {"wrap":"LanguageSelect_wrap__+jPi5","icon":"LanguageSelect_icon__Nzd5I","iconCompact":"LanguageSelect_iconCompact__LDS0y"};